/**
 * Shared file-download helpers.
 *
 * The app had this logic copied into several services with small differences, which is how one copy
 * ended up leaking object URLs. These two functions are the single version.
 */

/** Saves a blob to disk under the given name, always revoking the object URL afterwards. */
export const downloadBlob = (blob, filename) => {
  if (!blob) return false;

  const url = window.URL.createObjectURL(blob);
  try {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename || 'download');
    document.body.appendChild(link);
    link.click();
    link.remove();
    return true;
  } finally {
    window.URL.revokeObjectURL(url);
  }
};

/**
 * The server-chosen filename, falling back to the caller's when the header is missing or unreadable.
 * Handles both `filename=` and the RFC 5987 `filename*=UTF-8''` form, which is what carries Hebrew.
 */
export const filenameFromContentDisposition = (response, fallback) => {
  const header = response?.headers?.get?.('Content-Disposition');
  if (!header) return fallback;

  const encoded = header.match(/filename\*=\s*UTF-8''([^;\n]*)/i);
  if (encoded && encoded[1]) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch {
      // A malformed header is not worth failing a download over.
    }
  }

  const plain = header.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
  if (plain && plain[1]) {
    const name = plain[1].replace(/['"]/g, '').trim();
    if (name) return name;
  }

  return fallback;
};
